import AbstractView from "abstracts/AbstractView";
import Main from "controllers/Main";
import Screen from "controllers/Screen";

export default class ServicesImageAbstract extends AbstractView {
	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.velocity = 0;
	}

	initEl() {
		this.$canvas = $(document.createElement('canvas'));
		this.$wrapper.append(this.$canvas);
		this.ctx = this.$canvas[0].getContext('2d');
		this.tw.scroll = ScrollTrigger.create({
			trigger: this.$wrapper[0],
			onToggle: self => {
				if (self.isActive) {
					this.resume();
				} else {
					this.pause();
				}
			},
			onUpdate: self => {
				// console.log("direction:", self.direction, "velocity", self.getVelocity());
				this.velocity = self.getVelocity();
			}
		});
	}

	bindEvents() {
		Screen.on(Screen.E.RESIZE, this.resize, this);
	}

	unbindEvents() {
		Screen.off(Screen.E.RESIZE, this.resize, this);
		if (this.isVisible) {
			Main.off(Main.E.RAF, this.raf, this);
		}
		super.unbindEvents();
	}

	resize() {
		this.size = this.$wrapper.width();
		this.$canvas[0].style.width = this.size + 'px';
		this.$canvas[0].style.height = this.size + 'px';
		this.$canvas[0].width = this.size;
		this.$canvas[0].height = this.size;
	}

	raf() {
		if (this.isVisible) {
			this.updateCanvas();
		}
	}

	updateCanvas() {

	}

	pause() {
		this.isVisible = false;
		Main.off(Main.E.RAF, this.raf, this);
	}

	resume() {
		this.isVisible = true;
		Main.on(Main.E.RAF, this.raf, this);
	}
}
